import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get(action) {
    const { vin } = action.payload;

    try {
        const url = `${config.api.paths.vinDecoder}?vin=${encodeURIComponent(
            vin
        )}`;

        const { data } = yield call(http.authorized.get, url);

        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On VIN decoder get:", { error });
        console.error("VIN decoder get error:", error);
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.VIN_DECODER_GET_REQUEST, get)]);
}